import React from "react";
import { Form } from "@/commons/components";

const ReverseFormComponentLayout = ({
  title,
  onSubmit,
  vas,
  formFields,
  itemsEvents,
}) => {
  return (
    <Form title={title} onSubmit={onSubmit}>
      {formFields}
      {vas}
      <div className="card-actions col-end-3 justify-end">{itemsEvents}</div>
    </Form>
  );
};

export default ReverseFormComponentLayout;